import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Grid, TextField, Button, Box, InputAdornment } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import "./CreateEngineer.css"; // Uses same style as CreateSite.css
import axios from "axios";
import apiService from "../../utils/apiservice";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import { useEffect } from "react";


const CreateEngineer = () => {
  const [engineerData, setEngineerData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_no: "",
     customer_id: "",
  });
  const [customers, setCustomers] = useState([]);
const [selectedCustomer, setSelectedCustomer] = useState("");
const nameRegex = /^[A-Za-z]{2,20}$/;
//  const emailRegex = /^(?=.{2,50}$)[a-zA-Z0-9._]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
const emailRegex =
  /^(?!.*\.\.)(?!\.)([A-Za-z0-9._%+-]+)@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();


  const API_URL = process.env.REACT_APP_API_DJANGO_URL;




  // Generates strong password
// const generatePassword = (length = 10) => {
//   const chars =
//     "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()";
//   let password = "";
//   for (let i = 0; i < length; i++) {
//     password += chars.charAt(Math.floor(Math.random() * chars.length));
//   }
//   return password;
// };

 const validateField = (name, value) => {
  let error = "";

  if (name === "first_name" || name === "last_name") {
    if (!value) {
      error = "Required";
    } else if (!nameRegex.test(value)) {
      error = "Min 2 and max 20 alphabets are allowed.";
    }
  }

if (name === "email") {

  if (!value) {
    error = "Email is required";
  }

  else if (value.includes("..")) {
    error = "Multiple consecutive dots are not allowed";
  }

  else if (
    value.startsWith(".") ||
    value.endsWith(".")
  ) {
    error = "Dot cannot be at start or end";
  }

  else if (!emailRegex.test(value)) {
    error = "Invalid email format";
  }
}

  if (name === "phone_no") {
    if (!value) {
      error = "Phone number required";
    } else if (!/^[6-9]\d{9}$/.test(value))  {
      error = "Must be exactly 10 digits";
    }
  }

  return error;
};

const validateForm = () => {
  const newErrors = {};

  Object.keys(engineerData).forEach((key) => {
    const error = validateField(key, engineerData[key]);
    if (error) newErrors[key] = error;
  });

  setErrors(newErrors);

  return Object.keys(newErrors).length === 0;
};



  const handleChange = (e) => {
  const { name, value } = e.target;

  let updatedValue = value;

  // ✅ First & Last Name: remove spaces + only alphabets
  if (name === "first_name" || name === "last_name") {
    updatedValue = value
      .replace(/\s/g, "")        // ❌ remove ALL spaces
      .replace(/[^A-Za-z]/g, ""); // ❌ remove numbers & special chars
  }

  // ✅ Email: remove starting space
  if (name === "email") {
    updatedValue = value.replace(/^\s/, "").toLowerCase();
  }

  // ✅ Phone: only digits, max 10
  if (name === "phone_no") {
    updatedValue = value
      .replace(/\D/g, "")        // only digits
      .slice(0, 10);  
      
      if (updatedValue.length === 1 && !/[6-9]/.test(updatedValue)) {
    updatedValue = "";
  }// max 10
  }


  setEngineerData((prev) => ({
    ...prev,
    [name]: updatedValue
  }));

  // ✅ Runtime validation
  const error = validateField(name, updatedValue);

  setErrors((prev) => ({
    ...prev,
    [name]: error
  }));
};




useEffect(() => {
  const fetchCustomers = async () => {
    try {
      const response = await apiService({
        url: "/api/get_customers/",
        method: "GET",
      });

      const customerData = response?.data?.data || response?.data || [];
      setCustomers(customerData);

      // auto-select first customer
      if (customerData.length > 0) {
        const firstId = customerData[0].tb_customer_id;

        setSelectedCustomer(firstId);

        setEngineerData((prev) => ({
          ...prev,
          customer_id: firstId,
        }));
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
      toast.error("Failed to load customers");
    }
  };

  fetchCustomers();
}, []);

const handleFormSubmit = async (e) => {
  e.preventDefault();

  if (!validateForm()) return;

  try {
    const token = localStorage.getItem("accessToken");
    // const customerId = localStorage.getItem("customer_id");

    if (!token) {
      toast.error("No token found! Please login first.");
      return;
    }

    
    // ✅ Generate password dynamically
    // const password = generatePassword(10);

    const payload = {
      ...engineerData,
      customer_id: engineerData.customer_id, 
      // password: password,
    };

    // const response = await axios({
    //   url: `${API_URL}/api/create_site_engineer_by_admin/`,
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Accept: "application/json",
    //     Authorization: `Bearer ${token}`,
    //   },
    //   data: payload,
    // });
const response = await apiService.post(
        "/api/create_site_engineer_by_admin/",
        payload,
        {}
      );
    console.log("Engineer created:", response.data);

    // ✅ Show password in toast (optional)
    toast.success("Engineer Created Successfully");

    // Reset form
    setEngineerData({
      first_name: "",
      last_name: "",
      email: "",
      phone_no: "",
    });

    setErrors({});
  } catch (error) {
    console.error("Error:", error.response?.data || error.message);

    toast.error(
      error.response?.data?.error || "Failed to create engineer"
    );
  }
};

  return (
    <Box component="form" className="create-site-form-container" onSubmit={handleFormSubmit}>
      
      <Grid item xs={12} sm={6}>
  <FormControl fullWidth className="create-site-input">
    <InputLabel id="customer-label">Select Customer</InputLabel>

    <Select
      labelId="customer-label"
      value={selectedCustomer}
      label="Select Customer"
      onChange={(e) => {
        const customerId = e.target.value;

        setSelectedCustomer(customerId);

        setEngineerData((prev) => ({
          ...prev,
          customer_id: customerId,
        }));
      }}
    >
      {customers.map((customer) => (
        <MenuItem
          key={customer.tb_customer_id}
          value={customer.tb_customer_id}
        >
          {customer.customer_name}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
</Grid>
      <Grid container spacing={3}>

        

        {/* First Name */}
        <Grid item xs={12} sm={6}>
          <TextField
            className="create-site-input"
            label="First Name"
            name="first_name"
            value={engineerData.first_name}
            onChange={handleChange}
            required
            error={!!errors.first_name}
            helperText={errors.first_name || ""}
          
          />
        </Grid>

        {/* Last Name */}
        <Grid item xs={12} sm={6}>
          <TextField
            className="create-site-input"
            label="Last Name"
            name="last_name"
            value={engineerData.last_name}
            onChange={handleChange}
            required
            error={!!errors.last_name}
            helperText={errors.last_name || ""}
          />
        </Grid>

        {/* Email */}
        <Grid item xs={12}>
          <TextField
            className="create-site-input"
            label="Email Address"
            name="email"
            type="email"
            value={engineerData.email}
            onChange={handleChange}
            onKeyDown={(e) => {
              if (e.key === " ") e.preventDefault();
            }}
            required
            error={!!errors.email}
            helperText={errors.email || ""}
          
          />
        </Grid>

        {/* Phone Number */}
        <Grid item xs={12}>
          <TextField
            className="create-site-input"
            label="Phone Number"
            name="phone_no"
            value={engineerData.phone_no}
            onChange={handleChange}
            required
            error={!!errors.phone_no}
            helperText={errors.phone_no || ""}
           
          />
        </Grid>

      </Grid>

      <Box className="submit-btn-wrapper" display="flex" gap={2} mt={3}>
        <Button
          type="button"
          variant="outlined"
          className="submit-btn cancel-btn" 
          onClick={() => {
            setEngineerData({ first_name: "", last_name: "", email: "", phone_no: "" });
            setErrors({});
            navigate("/dashboard");
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          size="large"
          className="submit-btn"
        >
          Create Engineer
        </Button>
      </Box>

      <ToastContainer position="top-right" autoClose={3000} />
    </Box>
  );
};

export default CreateEngineer;